import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { 
  FaBarcode, FaQrcode, FaBoxes, FaWarehouse, 
  FaPlus, FaMinus, FaHome, FaChartBar, FaList
} from 'react-icons/fa';

const MobileQuickOps = () => {
  const navigate = useNavigate();
  const { user } = useSelector(state => state.auth);
  const [activeTab, setActiveTab] = useState('home');
  
  // 检测是否为移动设备
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const quickActions = [
    {
      icon: <FaBarcode className="text-3xl" />,
      title: '扫码出库',
      subtitle: '快速扫描出库',
      color: 'bg-blue-500',
      action: () => navigate('/admin/inventory?action=outbound')
    },
    {
      icon: <FaPlus className="text-3xl" />,
      title: '商品入库',
      subtitle: '新增库存',
      color: 'bg-green-500',
      action: () => navigate('/admin/inventory?action=inbound')
    },
    {
      icon: <FaBoxes className="text-3xl" />,
      title: '库存查询',
      subtitle: '查看库存状态',
      color: 'bg-purple-500',
      action: () => navigate('/admin/inventory')
    },
    {
      icon: <FaWarehouse className="text-3xl" />,
      title: '仓库管理',
      subtitle: '查看各仓库',
      color: 'bg-orange-500',
      action: () => navigate('/admin/inventory#warehouses')
    },
    {
      icon: <FaList className="text-3xl" />,
      title: '交易记录',
      subtitle: '查看历史',
      color: 'bg-red-500',
      action: () => navigate('/admin/inventory/transactions')
    },
    {
      icon: <FaChartBar className="text-3xl" />,
      title: '统计分析',
      subtitle: '销售数据',
      color: 'bg-indigo-500',
      action: () => navigate('/admin/analytics')
    }
  ];

  return (
    <div className="min-h-screen bg-gray-100 pb-16">
      {/* 顶部标题栏 */}
      <div className="bg-white shadow-sm sticky top-0 z-30">
        <div className="px-4 py-3">
          <h1 className="text-xl font-bold text-gray-800">快速操作</h1>
          <p className="text-sm text-gray-600">{user?.full_name || user?.phone_number}</p>
        </div>
      </div>

      {/* 快速操作网格 */}
      <div className="p-4">
        <div className="grid grid-cols-2 gap-4">
          {quickActions.map((action, index) => (
            <button
              key={index}
              onClick={action.action}
              className={`${action.color} text-white rounded-xl p-6 shadow-lg active:scale-95 transition-transform`}
            >
              <div className="flex flex-col items-center space-y-2">
                {action.icon}
                <span className="font-semibold text-lg">{action.title}</span>
                <span className="text-xs opacity-90">{action.subtitle}</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* 底部导航栏 */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg z-40">
        <div className="grid grid-cols-4 py-2">
          <button
            onClick={() => navigate('/admin/mobile')}
            className={`flex flex-col items-center py-2 ${
              activeTab === 'home' ? 'text-blue-600' : 'text-gray-500'
            }`}
          >
            <FaHome className="text-xl" />
            <span className="text-xs mt-1">首页</span>
          </button>
          <button
            onClick={() => navigate('/admin/inventory')}
            className={`flex flex-col items-center py-2 ${
              activeTab === 'inventory' ? 'text-blue-600' : 'text-gray-500'
            }`}
          >
            <FaBoxes className="text-xl" />
            <span className="text-xs mt-1">库存</span>
          </button>
          <button
            onClick={() => navigate('/admin/products')}
            className={`flex flex-col items-center py-2 ${
              activeTab === 'products' ? 'text-blue-600' : 'text-gray-500'
            }`}
          >
            <FaList className="text-xl" />
            <span className="text-xs mt-1">产品</span>
          </button>
          <button
            onClick={() => navigate('/admin')}
            className={`flex flex-col items-center py-2 ${
              activeTab === 'more' ? 'text-blue-600' : 'text-gray-500'
            }`}
          >
            <FaChartBar className="text-xl" />
            <span className="text-xs mt-1">更多</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileQuickOps;